import { Component, OnInit } from '@angular/core';
import { MyMenuService } from '../../tool/service/menu.service';

@Component({
  selector: 'ngx-user',
  styleUrls: ['user.component.scss'],
  template: ``,
})
export class UserComponent {

    menu = [];

    constructor(private ms :MyMenuService,) { }
  
    ngOnInit(): void {
      //this.menu = this.ms.menu    
    }
  
  }

